import styled from "styled-components";

const Whole = styled.div`
    height : 10vh;
    width : 100vw;
    background-color : greenyellow;
    `

const TopBar = () => {
    return(
        <Whole/>
    );
};

export default TopBar;